module.exports = __webpack_public_path__ + "static/media/results_teams.3bd0e762.pdf";